import { Link } from "react-router-dom";
import { GraduationCap, Users, ClipboardCheck, Gavel, FileCog, ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { StaggerGroup, StaggerItem, Reveal } from "../components/Reveal";

const ITEMS = [
  {
    icon: GraduationCap,
    title: "Expanded tax services",
    detail:
      "Added two new school districts for school tax collection, bringing the total to five.",
  },
  {
    icon: Users,
    title: "Staff cross-training",
    detail:
      "Implemented a program so every team member can perform all departmental functions and answer public questions across every area of responsibility.",
  },
  {
    icon: ClipboardCheck,
    title: "Improved hiring standards",
    detail:
      "Updated position titles and requirements to ensure hiring aligns with the office's mission.",
  },
  {
    icon: Gavel,
    title: "First property auction in two years",
    detail:
      "Completed successfully while navigating complex new federal and state legislation affecting how counties handle property foreclosures.",
  },
  {
    icon: FileCog,
    title: "Modernizing operations",
    detail:
      "Currently rewriting departmental policies and procedures to reflect current needs and best practices.",
  },
];

export default function Accomplishments() {
  return (
    <div data-testid="accomplishments-page">
      <PageHero
        eyebrow="The Record"
        title="Accomplishments in office"
        intro="Concrete results delivered for Ontario County taxpayers over four-plus years in the Treasurer's Office."
        testid="accomplishments-hero"
      />

      <section className="py-20 md:py-28 bg-background">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <StaggerGroup className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" stagger={0.09}>
            {ITEMS.map((item, i) => {
              const Icon = item.icon;
              return (
                <StaggerItem key={i}>
                  <article
                    data-testid={`accomplishment-card-${i}`}
                    className="group h-full bg-white border border-slate-200 p-8 rounded-sm transition-all duration-300 hover:shadow-[0_-3px_0_0_hsl(var(--campaign-red))] hover:border-slate-300 hover:-translate-y-1"
                  >
                    <div className="flex items-center justify-between">
                      <div className="h-12 w-12 flex items-center justify-center bg-[hsl(var(--navy))] text-white rounded-sm group-hover:bg-red-700 transition-colors">
                        <Icon size={22} />
                      </div>
                      <span className="font-mono-num text-3xl font-bold text-slate-200 group-hover:text-red-100 transition-colors">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-[hsl(var(--navy))]">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-slate-600 leading-relaxed">{item.detail}</p>
                  </article>
                </StaggerItem>
              );
            })}

            {/* Balancing editorial cell */}
            <StaggerItem>
              <div className="h-full bg-[hsl(var(--navy))] text-white p-8 rounded-sm flex flex-col justify-between paper-grain">
                <p className="font-display italic text-2xl leading-snug text-balance">
                  "Setting the standard for how the department fulfills its obligations to taxpayers."
                </p>
                <Link
                  to="/donate"
                  data-testid="accomplishments-support-btn"
                  className="focus-ring group mt-8 inline-flex items-center gap-2 font-semibold text-red-300 hover:text-white transition-colors"
                >
                  Support the campaign
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </StaggerItem>
          </StaggerGroup>
        </div>
      </section>
    </div>
  );
}
